import { useEffect, useState } from "react";
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  Stack,
  Chip,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";

import { useSDGs } from "../../hooks/useSDGs";
import { ODS_IMAGES } from "../../support/Constants";

export const ODSSelector = ({ onChange, defaultValue }) => {
  const [selectedSdgs, setSelectedSdgs] = useState([]);
  
  const normalize = (input) => {
    const toBaseSdg = (v) => {
      const m = String(v)
        .trim()
        .match(/^(\d{1,2})/);
      if (!m) return null;
      const n = parseInt(m[1], 10);
      return n >= 1 && n <= 17 ? n : null;
    };

    const arr = Array.isArray(input)
      ? input
      : String(input ?? "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);

    const cleaned = arr
      .map(toBaseSdg)
      .filter((n) => n !== null);

    return Array.from(new Set(cleaned)).sort((a, b) => a - b);
  };

  useEffect(() => {
    setSelectedSdgs(normalize(defaultValue || []));
  }, [defaultValue]);

  const changeHandler = (e) => {
    setSelectedSdgs(e.target.value);
    onChange(e.target.value.map((n) => parseInt(n)));
  };

  const onDelete = (values) => {
    setSelectedSdgs(values);
    onChange(values.map((sdg) => parseInt(sdg)));
  };

  const { sdgs } = useSDGs();

  const sdgsMap = sdgs?.reduce(
    (prev, curr) => ({
      ...prev,
      [curr.id]: { id: curr.id, description: curr.description },
    }),
    {}
  );

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>ODS de tu proyecto</InputLabel>
      <Select
        multiple
        value={selectedSdgs}
        onChange={changeHandler}
        input={<OutlinedInput label="ODSs de tu proyecto" />}
        renderValue={(selected) => (
          <Stack gap={1} direction="row" flexWrap="wrap">
            {selected.map((value) => (
              <Chip
                key={value}
                label={
                  <Stack direction="row" alignItems="center" gap={1}>
                    <img
                      src={ODS_IMAGES[value]}
                      width="20px"
                      height="20px"
                      alt=""
                    />
                    <span>{sdgsMap[value]?.description}</span>
                  </Stack>
                }
                onDelete={() => {
                  const filteredArray = selectedSdgs.filter(
                    (item) => item !== value
                  );
                  onDelete(filteredArray);
                }}
                deleteIcon={
                  <CancelIcon
                    onMouseDown={(event) => event.stopPropagation()}
                  />
                }
              />
            ))}
          </Stack>
        )}
      >
        {sdgs.map(({ id, description }) => (
          <MenuItem
            key={description}
            value={id}
            sx={{ justifyContent: "space-between" }}
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <img src={ODS_IMAGES[id]} width="20px" height="20px" alt="" />
              {description}
            </Stack>
            {selectedSdgs.includes(id) ? <CheckIcon color="info" /> : null}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
